import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NotificationService } from "src/app/services/notification.service";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";
import { RegistruService } from "../registru.service";
import { finalize } from "rxjs";
import { formatDate } from "@angular/common";

@Component({
    selector: "app-add-prelungire",
    templateUrl: "./add-prelungire.component.html",
    styleUrls: ["./add-prelungire.component.scss"],
})
export class AddPrelungireComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;
    token!: string;
    isLoading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<AddPrelungireComponent>,
        private notificationService: NotificationService,
        private registruService: RegistruService
    ) {
        console.log(data);
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    form: FormGroup = new FormGroup({
        document_data: new FormControl(new Date(), Validators.required),
        cerere_numar: new FormControl("", Validators.required),
        cerere_data: new FormControl(new Date(), Validators.required),
        valability: new FormControl(new Date(), Validators.required),
        observatii: new FormControl(""),
    });

    submitForm() {
        this.isLoading = true;

        const { document_data, cerere_numar, cerere_data, valability, observatii } = this.form.value;

        let payload = {
            document_data: document_data.toISOString(),
            cerere_numar: cerere_numar,
            cerere_data: cerere_data.toISOString(),
            valability: valability.toISOString(),
            observatii: observatii,
            document_data_off: formatDate(document_data, 'yyyy-MM-dd', 'en-US'),
            cerere_data_off: formatDate(cerere_data, 'yyyy-MM-dd', 'en-US'),
            valability_off: formatDate(valability, 'yyyy-MM-dd', 'en-US'),
            off_id: this.data.id,
            type_id: this.data.type_id,
            // extension_type: 1,
        };

        // console.log("submit prelungire", payload);

        this.registruService
            .editDataRegistru(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (response: any) => {
                    if (response) {
                        this.dialogRef?.close({
                            success: true,
                        });
                    }
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
